import React, { Component } from "react";
import Sidebar from "./Sidebar";
import { BrowserRouter, Route, Router } from "react-router-dom";
import Loop from "../Loop/Loop";
import About from "../About/About";
import Login from "../Login/Login";
import Electricity from "../Electricity/Electricity";
import Result from "../Result/Result";
import Callback from "./Callback";
import RemoteControl from "../Loop/RemoteControlLoop";
import axios from "axios";
import PointContainer from "../Loop/PointContainer";

import Auth from "../../authentication/auth";
import history from "../../authentication/history";




var mqtt = require("mqtt");
var host = "wss://iot.research.hamk.fi:443/mqtt";
var options = {
  keepalive: 3600,
  protocolId: "MQTT",
  protocolVersion: 4,
  clean: true,
  reconnectPeriod: 1000,
  connectTimeout: 30 * 1000,
  will: {
    topic: "WillMsg",
    payload: "Connection Closed abnormally..!",
    qos: 0,
    retain: false,
  },
  username: "",
  password: "",
  rejectUnauthorized: false,
};
var mqttClient = mqtt.connect(host, options);

// subscribe to all topic with kontti/ui
mqttClient.on("connect", function () {
  mqttClient.subscribe("hamk/iot/valkeakoski/kontti/ui/#");
});


const auth = new Auth();

const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
};

export default class Home extends Component {
  state = {
    pointsSchema: [],
    mqttMessages: [],
  };

  componentDidMount() {
    axios
      .get(`https://iot.research.hamk.fi/api/v1/kontti/TOE/pointsSchema`)
      .then((res) => {
        const pointsSchema = res.data;
        this.setState({ pointsSchema });
      });

    const setMqttState = (message, topic) => {
      this.setState({ [topic]: message });
    };

    mqttClient.on("message", function (topic, message) {
      let mqttMessages = JSON.parse(message.toString()); // parse buffer to string
      let mqttTopic = topic.toString().slice(31); // slice off "hamk/iot/valkeakoski/kontti/ui/" part, leaving only TE,PE,etc.
      setMqttState(mqttMessages, mqttTopic);
    });
  }

  componentDidUpdate() {
    //console.log(this.state['hamk/iot/valkeakoski/kontti/ui/HV'])
  }

  render() {
    const {
      F1,
      F2,
      TE,
      SC,
      P1,
      P2,
      P3,
      HV,
      AK,
      O2,
      Fan,
      Burning,
      Error,
      BoilerBurner,
      FeederControl,
      OverrideBurningProsess,
      OverrideFeederSpeedControl,
      OverrideSolarProsess,
      OverrideTankProsess,
      SolarLoopCharge,
      WaterTankCharge,
      FeederSpeedControl,
      OverridePrimaryFanSpeed,
      PrimaryFanSpeed,
      TestingMode,
      BurningTemp,
      WaterTemp,
    } = this.state;

    const messages = {
      ...P1,
      ...P2,
      ...P3,
      ...F1,
      ...F2,
      ...TE,
      ...SC,
      ...HV,
      ...AK,
      ...O2,
      ...Fan,
      ...Burning,
      ...Error,
      ...BoilerBurner,
      ...FeederControl,
      ...OverrideBurningProsess,
      ...OverrideFeederSpeedControl,
      ...OverrideSolarProsess,
      ...OverrideTankProsess,
      ...SolarLoopCharge,
      ...WaterTankCharge,
      ...FeederSpeedControl,
      ...OverridePrimaryFanSpeed,
      ...PrimaryFanSpeed,
      ...TestingMode,
      ...BurningTemp,
      ...WaterTemp,
    }

    return (
      <Router history={history}>
        <BrowserRouter>
          <Sidebar>
            <Route exact path="/venect" render={(props) => {
                return <Loop messages={messages} />;
              }} />
            <Route path="/venect/about" component={About} />
            <Route path="/venect/electricity" component={Electricity} />
            <Route path="/venect/result" component={Result} />
            {/* <Route path="/venect/login" component={<Login auth={auth}/>} /> */}
            <Route
              path="/venect/callback"
              render={(props) => {
                handleAuthentication(props);
                return <Callback {...props} />;
              }}
            />
            <Route
              path="/venect/login"
              render={(props) => {
                return <Login auth={auth} {...props} />;
              }}
            />
            <Route
              path="/venect/remote-control"
              render={(props) => {
                return <RemoteControl auth={auth} {...props} messages={messages} pointsSchema={this.state.pointsSchema} />;
              }}
            />
          </Sidebar>
        </BrowserRouter>
      </Router>
    );
  }
}
